import React from "react";
import axios from 'axios';
import '../BillPayComponent/billPayy.css';
import $, { timers } from "jquery";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import FooterComponet from "../FooterComponent/FooterComponet";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import './merchantpayout.css';
import HeadeCommon from "../HeaderComponent/HeadeCommon";
import Menu from "../MenuComponent/Menu";

import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
import { selectedBeneList, selectedSender, setBranchAddress, setIfscCode, setSelectedBankId, setSelectedBankName, setSendersListDetails, setTxnHistoryElementNo } from "../../redux/misc-data/misc-data.action";
import { setCreateOrderRes, setCreteOrderReq, setMoneyTransferTotalAmount } from "../../redux/payout/payout.action";

const httpClient = axios.create();
class MerchantPayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            amount: '',
            enableMerchantPayout: false,
            merchantDetails: '',
            retailerBalance: '',
            amount: '',
        }
    }





    componentDidMount() {
        this.getMerchantDetails();
        this.getPayoutAvailableBalance();
    }
    componentWillUnmount() {
    }

    enterAmount = (event) => {
        this.setState({
            amount: event.target.value
        })
    }



    validationWithRegex(value, regex) {
        console.log('validationWithRegex value=' + value + ';regex=' + regex);
        if (regex != null && regex != undefined && regex != '') {
            var re = new RegExp(regex);
            if (!re.test(value)) {

                return false;
            }
            else {

                return true;
            }
        } else {
            return true;
        }

    }

    getSenderDetils = (mobileNo) => {

        this.setState({
            showSenderVisible: false
        })
        store.dispatch(setSendersListDetails(''));

        var allsenderuRL = '/api/v1/dmt/customer/details/' + mobileNo;
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.get(allsenderuRL, { headers }
        ).then((response) => {
            console.log('selected sender response' + JSON.stringify(response.data));
            console.log(response.data.response.msg);
            if (response.data.response.msg == 'SUCCESS') {


                store.dispatch(selectedSender(response.data));
                store.dispatch(selectedBeneList(response.data.customer.beneficiaries));

                store.dispatch(setSelectedBankName(''));
                store.dispatch(setIfscCode(''));
                store.dispatch(setBranchAddress(''));
                store.dispatch(setSelectedBankId(''));

                console.log('calling add account API');


                var gotoAddAccountPage = document.getElementById('gotoAddAccountPage');
                gotoAddAccountPage.click();

            } else {
                this.errorMessageCall(response.data.response.displayMsg);
            }
        }).catch(error => {

            this.errorMessageCall(error.msg);
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {

                this.getSenderDetils();
            }
        });
    }
    getPayoutAvailableBalance = () => {
        var url = '/api/v1/account/balance/';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.get(url + this.props.agentInfo.id, { headers }
        ).then((response) => {
            var retailerBalanceVal = response.data.balance + response.data.creditLimit -
                response.data.lien;
            this.setState({
                retailerBalance: retailerBalanceVal
            })
        }).catch(error => {


            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }

       
        });
    }

    createOrder = (event) => {
        event.preventDefault();

        this.setState({
            progress: 'start',
            orderprocessing: 'start',
            transfernowBtnBlock: false
        });

        var header = '';
        header = {
            msgType: "CREATE_ORDER",
            src: 'merchant-payout',
            dst: 'merchant-payout',
            service: "PAYOUT",
            channel: "WHITELABEL",
            requesterId: 'P0347931308FXP',//this.props.clientRequesterId,
            requestId: uuidv4(),
            time: moment().utc(),
        }

        var transaction = '';
        transaction = {
            amount: parseFloat(this.state.amount).toFixed(2),
            operator: 'IMPS',
            customerId:  this.props.agentInfo.id,
            mobile: this.props.agentInfo.mobile,
            operator_code: ''
        }

        var optional = new Map();
        optional.set("BENEFICIARY_ID", this.state.merchantDetails.beneficiary.id);
        optional.set("txnPass", "675743")



        var createOrderRequest = '';
        createOrderRequest = {
            header: header,
            device: this.props.deviceInfo,
            transaction: transaction,
            validated: true,
            payment: "PARTNER_BALANCE",
            agentId: this.props.agentInfo.id,
            optional: Object.fromEntries(optional),
        }

        var createOrderUrl = '';
        createOrderUrl = '/api/v1/payout/order/create';


        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        console.log('create order req:' + JSON.stringify(createOrderRequest));

        httpClient.post(createOrderUrl, createOrderRequest, {
            timeout: 60 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {
            console.log('create order response' + JSON.stringify(response.data));
            if (response.data.response.success == true) {
                this.setState({
                    progress: 'finished',
                    orderprocessing: 'end',
                })

                store.dispatch(setCreteOrderReq(createOrderRequest));
                store.dispatch(setCreateOrderRes(response.data));
                store.dispatch(setMoneyTransferTotalAmount(this.props.aepsAmount));

                var gotomoneytransferDetails = document.getElementById('gotomoneytransferDetails');
                gotomoneytransferDetails.click();

            } else {
                this.setState({
                    progress: 'finished',
                    orderprocessing: 'end',
                    transfernowBtnBlock: true
                })
                this.errorMessageCall(response.data.response.displayMsg);

            }
        }).catch(error => {
            this.setState({
                progress: 'finished',
                orderprocessing: 'end',
                transfernowBtnBlock: true
            })
            this.setState({
                progressStatus: false
            })
            this.errorMessageCall('Something went wrong,please try again later!');

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }
        })
    }




    getMerchantDetails() {
        var url = '/api/v1/payout/connector/get-merchant-details/'
            + this.props.agentInfo.id;
            
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }
        httpClient.get(url, {
            timeout: 60 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {
            console.log(' get merchant details response' + JSON.stringify(response.data));

            if (response.data.response.msg == 'SUCCESS') {

                var tpsRspMsg = response.data.response.tpsRspMsg.toLowerCase();
                if (tpsRspMsg.includes("please upload")) {

                    var accountImageUpload = document.getElementById('accountImageUpload');
                    accountImageUpload.click();

                } else if (tpsRspMsg.includes("unable to add account")) {
                    this.setState({
                        errorMessage: response.data.response.tpsRspMsg.replace("displayMsg:", "")
                    })
                } else if (response.data.beneficiary.verified == true &&
                    response.data.beneficiary.active == true) {
                    this.setState({
                        enableMerchantPayout: true,
                        merchantDetails: response.data
                    })
                } else {
                    this.setState({
                        errorMessage: response.data.response.tpsRspMsg.replace("displayMsg:", "")
                    })
                }

            } else {
                console.log('calling add account API');
                var gotoAddAccountPage = document.getElementById('gotoAddAccountPage');
                gotoAddAccountPage.click();

            }
        }).catch(error => {
            this.setState({
                errorMessage: 'Error in fetching merchant details'
            })
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }
        })
    }






    render() {


        return (

            <div>
                <HeadeCommon />
                <Menu />


                <div class="main">
                    <div class="container-fluid">
                        <div class="head">
                            <h3>Merchant Payout</h3>
                            <button class="btn" type="button" onclick="window.location.href='dashboard.html'">Back</button>
                        </div>
                        <Link to='/add-account'>
                            <button id="gotoAddAccountPage" hidden={true}></button>
                        </Link>
                        <Link to='/doc-upload'>
                            <button id="accountImageUpload" hidden={true}></button>
                        </Link>

                        <div class="usercard">
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="merchant-dtls">
                                        {/* <img src="images/merchant.png" alt="Merchant" class="img-fluid"/> */}
                                        <h6>{this.props.agentInfo.kioskName.toUpperCase()}</h6>
                                        <p>RO ID: <strong>
                                            {this.props.agentInfo.id}
                                        </strong></p>
                                    </div>

                                    <div class="merchant-other-dtls">
                                        <p>Mobile Number:</p>
                                        <h6>{(this.state.merchantDetails != '' &&
                                            this.state.merchantDetails.beneficiary.mobile != null &&
                                            this.state.merchantDetails.beneficiary.mobile != '') ?
                                            this.state.merchantDetails.beneficiary.mobile :
                                            "NA"
                                        }</h6>

                                        <p>Company Email ID:</p>
                                        <h6>{(this.state.merchantDetails != '' &&
                                            this.state.merchantDetails.beneficiary.email != null &&
                                            this.state.merchantDetails.beneficiary.email != '') ?
                                            this.state.merchantDetails.beneficiary.email :
                                            "NA"
                                        }</h6>

                                        <p>Account Number:</p>
                                        <h6>{(this.state.merchantDetails != '' &&
                                            this.state.merchantDetails.beneficiary.account.accNum != null &&
                                            this.state.merchantDetails.beneficiary.account.accNum != '') ?
                                            this.state.merchantDetails.beneficiary.account.accNum :
                                            "NA"
                                        }</h6>

                                        {/* <p>GST Number:</p>
                                        <h6>GST20222103GGN06</h6> */}
                                    </div>
                                </div>

                                <div class="col-12 col-md-6 col-lg-8">
                                    <div class="merchant-right">
                                        <div class="merchant-bank">
                                            <h4>Merchant  Bank Account Details</h4>

                                            <div class="merchant-bank-dtls">
                                                <div class="merchant-bank-name">
                                                    <img src="images/bank-logo.png" alt="Bank " class="img-fluid" />
                                                    <h5>{(this.state.merchantDetails != '' &&
                                                        this.state.merchantDetails.beneficiary.name != null &&
                                                        this.state.merchantDetails.beneficiary.name != '') ?
                                                        this.state.merchantDetails.beneficiary.name.toUpperCase() :
                                                        "NA"
                                                    }</h5>
                                                    <p>Ac No.: {(this.state.merchantDetails != '' &&
                                                        this.state.merchantDetails.beneficiary.account.accNum != null &&
                                                        this.state.merchantDetails.beneficiary.account.accNum != '') ?
                                                        this.state.merchantDetails.beneficiary.account.accNum :
                                                        "NA"
                                                    }</p>
                                                </div>
                                                <div class="dropdown-divider"></div>
                                                <div class="merchant-bank-name">
                                                    <h6>{(this.state.merchantDetails != '' &&
                                                        this.state.merchantDetails.beneficiary.account.bank != null &&
                                                        this.state.merchantDetails.beneficiary.account.bank != '') ?
                                                        this.state.merchantDetails.beneficiary.account.bank :
                                                        "NA"
                                                    }</h6>
                                                    <p>IFSC code: {(this.state.merchantDetails != '' &&
                                                        this.state.merchantDetails.beneficiary.account.ifsc != null &&
                                                        this.state.merchantDetails.beneficiary.account.ifsc != '') ?
                                                        this.state.merchantDetails.beneficiary.account.ifsc :
                                                        "NA"
                                                    }</p>
                                                </div>
                                            </div>

                                            <div class="payout-blc">
                                                <i class="ta"></i>
                                                <p>Payout Available Balance:</p>
                                                <h5>₹{this.state.retailerBalance}</h5>
                                            </div>

                                            <div class="payout-form">
                                                <div class="row">
                                                    <div class="col-12 col-md-6">
                                                        <div class="formrow">
                                                            <div class="form-floating">
                                                                <input type="text" class="form-control" id="amt" placeholder="amount"
                                                                    readOnly={this.state.enableMerchantPayout == false && true}
                                                                    onChange={this.enterAmount}
                                                                    value={this.state.amount} />

                                                                <label for="amt">Enter payout amount</label>

                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <div class="col-12 mt-3">
                                                        <div class="form-group form-check">
                                                            <input type="checkbox" class="form-check-input" id="exampleCheck1" />
                                                            <label class="form-check-label" for="exampleCheck1">I agree to the <a href="#">terms and conditions</a></label>
                                                        </div>
                                                    </div> */}
                                                    <form onSubmit={this.createOrder}>

                                                        <div class="col-12 mt-4">
                                                            <button class="btn btn-primary " type="submit"
                                                                disabled={this.state.enableMerchantPayout == false && true}>Proceed</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <FooterComponet />

            </div>
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, moneyTransferResponseDetails, createOrderResponseDetails,
            agentInfo, token, clientRole, clientRequesterId, selectSender, benefisciaryInfo, surcharge,
            transferTotalAmount, deviceInfo, customerLimit,
            customerId, bankLogoListTxt, billerData, paremeterData,
            callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, phone, moneyTransferResponseDetails,
    createOrderResponseDetails, agentInfo, token, clientRole, clientRequesterId, selectSender, benefisciaryInfo, surcharge,
    transferTotalAmount, deviceInfo, customerLimit,
    customerId, bankLogoListTxt, billerData, paremeterData,
    callBackUrl
});

export default connect(mapStateToProps, null)(MerchantPayout);

